<template>
    <div id="userdetail-page" class="mb-5">
        <b-card>
            <b-row>
              <b-col md="12">
              <h3>{{$route.name}}</h3>
              <b-breadcrumb>
                <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                <b-breadcrumb-item><router-link to="/company-structure/customer">Customer</router-link></b-breadcrumb-item>
                <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
              </b-breadcrumb>
              <div class="border-bottom"></div>
             </b-col>
            </b-row>
            <form v-on:submit.prevent="doEdit" class="mt-3">
              <div>
                <b-row>
                  <b-col md="5">
                    <b-row>
                      <b-col md="12 mb-3">
                        <label class="labels">Type *</label>
                        <b-form-select name="type" v-model="model.type" v-bind:class="errors.has('type') ? 'is-invalid':''" v-validate="modelValidations.type" :error="errors.first('type')" :options="typeList">
                        </b-form-select>
                        <!-- <b-form-select v-if="this.$route.params.id === undefined" name="type" v-model="model.type" v-bind:class="errors.has('type') ? 'is-invalid':''" v-validate="modelValidations.type" :error="errors.first('type')" :options="typeList">
                        </b-form-select>
                        <b-form-input v-else id="field-type" class="type-customer" name="type" readonly v-model="model.type" v-bind:class="errors.has('type') ? 'is-invalid':''" :error="errors.first('type')" /> -->
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12 mb-3">
                        <label class="labels">Sales Type *</label>
                        <b-form-select name="salesType" v-model="model.salesType" v-bind:class="errors.has('salesType') ? 'is-invalid' : ''" v-validate="modelValidations.salesType" :error="errors.first('salesType')" :options="salesTypeList" />
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>Please Select Sales Type</b-form-select-option>
                          </template>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="11">
                        <label class="labels">Business Sector *</label>
                        <b-form-select name="businessSector" id="labelAdd" v-model="model.businessSector" v-bind:class="errors.has('businessSector') ? 'is-invalid':''" v-validate="modelValidations.businessSector" :error="errors.first('businessSector')" :options="businessSectorList" />
                          <template v-slot:first>
                            <b-form-select-option :value="null" disabled>Please Select Business Sector</b-form-select-option>
                          </template>
                      </b-col>
                      <b-col md="1" id="buttonAdd">
                        <label class="labels"></label>
                        <b-button variant="primary" class="btn-custom" @click="showModalBusiness()" style="margin-left:-24px!important; margin-top:.4em!important;"><font-awesome-icon icon="plus"/></b-button>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12 mt-3">
                        <label class="labels">Customer Name *</label>
                        <div class="form-group" v-bind:class="errors.has('name') ? 'has-error':''">
                          <input type="text" class="form-control" v-bind:class="errors.has('name') ? 'is-invalid':''" data-vv-as="name" name="name" v-model="model.name" v-validate="'required'" placeholder="Enter Customer Name" />
                          <p v-if="errors.has('name') !== null"></p>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12">
                        <label class="labels">Market Segment *</label>
                        <b-form-select name="marketSegment" v-model="model.marketSegment" v-bind:class="errors.has('marketSegment') ? 'is-invalid':''" v-validate="modelValidations.marketSegment" :error="errors.first('marketSegment')" :options="marketSegmentList">
                        </b-form-select>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12 mt-3">
                        <label class="labels">Telephone</label>
                        <div class="form-group">
                          <input type="number" class="form-control" name="phone" v-model="model.phone" placeholder="Enter Telephone" />
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12">
                        <label class="labels">Fax Number </label>
                        <div class="form-group" v-bind:class="errors.has('fax') ? 'has-error':''">
                          <input type="number" class="form-control" v-bind:class="errors.has('fax') ? 'is-invalid':''" data-vv-as="fax" name="fax" v-model="model.fax" placeholder="Enter Fax Number" />
                          <p v-if="errors.has('fax') !== null"></p>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12">
                        <label class="labels">Website </label>
                        <div class="form-group" v-bind:class="errors.has('website') ? 'has-error':''">
                          <input type="text" class="form-control" v-bind:class="errors.has('website') ? 'is-invalid':''" data-vv-as="website" name="website" v-model="model.website" placeholder="Enter Website" />
                          <p v-if="errors.has('website') !== null"></p>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="11">
                        <label class="labels">Social Media </label>
                        <b-button id="buttonAdds" variant="primary" class="btn-custom" @click="addSocialMedia()" ><font-awesome-icon icon="plus"/></b-button>
                        <div v-for="(socialMedia, index) in socialMedias" v-bind:key="index">
                          <b-form-input type="text" class="mt-2" placeholder="Enter Social Media" v-model="socialMedia.name"/>
                          <b-button class="deleteSocialMedia" pill style="margin-top:-60px!important;font-weight:bold!important;padding-top:0px!important; padding-bottom:0px!important;" size="sm" variant="danger" @click="deleteSocialMedia(index)">x</b-button>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col md="2">
                  </b-col>
                  <b-col md="5">
                    <b-row>
                      <b-col md="12">
                        <label class="labels">Email *</label>
                        <div class="form-group" v-bind:class="errors.has('email') ? 'has-error':''">
                          <input type="email" class="form-control" v-bind:class="errors.has('email') ? 'is-invalid':''" data-vv-as="email" name="email" v-model="model.email" v-validate="'required'" placeholder="Ex: myname@example.com" />
                          <p v-if="errors.has('email') !== null"></p>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12">
                        <label class="labels">Tax ID </label>
                        <div class="form-group" v-bind:class="errors.has('taxId') ? 'has-error':''">
                          <input type="number" class="form-control" v-bind:class="errors.has('taxId') ? 'is-invalid':''" data-vv-as="taxId" name="taxId" v-model="model.taxId" placeholder="Enter Tax ID" />
                          <p v-if="errors.has('taxId') !== null"></p>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12">
                        <label class="labels">Address *</label>
                        <div class="form-group" v-bind:class="errors.has('address') ? 'has-error':''">
                          <b-form-textarea rows="5" type="text" class="pb-0 mb-0 form-control" v-bind:class="errors.has('address') ? 'is-invalid':''" data-vv-as="address" name="address" v-model="model.address" v-validate="'required'" placeholder="Enter Address" />
                          <p v-if="errors.has('address') !== null"></p>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12">
                        <label class="labels">State *</label>
                        <b-form-select name="state" v-model="model.state" v-validate="modelValidations.state" v-bind:class="errors.has('state') ? 'is-invalid':''" :error="errors.first('state')" :options="stateList">
                        </b-form-select>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12 mt-3">
                        <label class="labels">City *</label>
                        <!-- <b-form-select v-if="model.state === 'Malaysia'" name="city" v-model="model.city" v-validate="modelValidations.city" v-bind:class="errors.has('city') ? 'is-invalid':''" :error="errors.first('city')" :options="cityListRM">
                        </b-form-select>
                        <b-form-select v-else name="city" v-model="model.city" v-validate="modelValidations.city" v-bind:class="errors.has('city') ? 'is-invalid':''" :error="errors.first('city')" :options="cityListID">
                        </b-form-select> -->
                        <div class="form-group" v-bind:class="errors.has('city') ? 'has-error':''">
                          <input type="text" class="form-control" v-bind:class="errors.has('city') ? 'is-invalid':''" data-vv-as="city" name="city" v-model="model.city" v-validate="'required'" placeholder="Enter City" />
                          <p v-if="errors.has('city') !== null"></p>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12 mt-3">
                        <label class="labels">Postal Code *</label>
                        <div class="form-group" v-bind:class="errors.has('postalCode') ? 'has-error':''">
                          <input type="number" class="form-control" v-bind:class="errors.has('postalCode') ? 'is-invalid':''" data-vv-as="postalCode" name="postalCode" v-model="model.postalCode" v-validate="'required'" placeholder="Enter Postal Code" />
                          <p v-if="errors.has('postalCode') !== null"></p>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <b-row>
                      <b-col md="12 mt-3">
                        <label class="labels">Description </label>
                        <div class="form-group" v-bind:class="errors.has('description') ? 'has-error':''">
                          <b-form-textarea rows="5" type="text" class="form-control" v-bind:class="errors.has('description') ? 'is-invalid':''" data-vv-as="description" name="description" v-model="model.description" placeholder="Enter Description" />
                          <p v-if="errors.has('description') !== null"></p>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                  <div class="border-top mt-2 mb-0">
                  <b-button block v-if="model.type !== 'Individual' && model.type !== 'Government'" v-b-toggle.designated class="m-1 mt-2" variant="light" style="color:#0056b3!important;">Designated <font-awesome-icon icon="chevron-down" class="ml-3"/></b-button>
                  <b-collapse id="designated">
                    <b-card no-body class="mb-4">
                      <b-row>
                        <b-col md="5">
                          <label class="labels">PIC Name </label>
                          <div class="form-group" v-bind:class="errors.has('picName') ? 'has-error':''">
                            <input type="text" class="form-control" v-bind:class="errors.has('picName') ? 'is-invalid':''" data-vv-as="picName" name="picName" v-model="model.picName" placeholder="Enter PIC Name" />
                            <p v-if="errors.has('picName') !== null"></p>
                          </div>
                        </b-col>
                        <b-col md="2">
                        </b-col>
                        <b-col md="5">
                          <label class="labels" style="margin-right:15px!important;">Division </label>
                          <b-form-select name="divisionCustomer" style="width:86%!important;" v-model="model.divisionCustomer" v-bind:class="errors.has('divisionCustomer') ? 'is-invalid':''" :error="errors.first('divisionCustomer')" :options="divisionList">
                          </b-form-select>
                          <b-button variant="primary" class="btn-custom" style="margin-left:8px!important;" @click="showModalDivision()" ><font-awesome-icon icon="plus"/></b-button>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col md="5">
                          <label class="labels">Gender </label>
                          <b-form-select name="gender" v-model="model.gender" v-bind:class="errors.has('gender') ? 'is-invalid':''" :error="errors.first('gender')" :options="genderList">
                          </b-form-select>
                        </b-col>
                        <b-col md="2">
                        </b-col>
                        <b-col md="5">
                          <label class="labels" style="margin-right:15px!important;">Position </label>
                          <b-form-select name="positionCustomer" style="width:86%!important;" v-model="model.positionCustomer" v-bind:class="errors.has('positionCustomer') ? 'is-invalid':''" :error="errors.first('positionCustomer')" :options="positionList">
                          </b-form-select>
                          <b-button variant="primary" class="btn-custom" style="margin-left:8px!important;" @click="showModalPosition()" ><font-awesome-icon icon="plus"/></b-button>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col md="5 mt-3">
                          <label class="labels">Phone 1 </label>
                          <div class="form-group" v-bind:class="errors.has('workphone') ? 'has-error':''">
                            <input type="number" class="form-control" v-bind:class="errors.has('workphone') ? 'is-invalid':''" data-vv-as="workphone" name="workphone" v-model="model.workphone" placeholder="Enter Phone 1" />
                            <p v-if="errors.has('workphone') !== null"></p>
                          </div>
                        </b-col>
                        <b-col md="2">
                        </b-col>
                        <b-col md="5 mt-3">
                          <label class="labels">Work Email </label>
                          <div class="form-group" v-bind:class="errors.has('workemail') ? 'has-error':''">
                            <input type="email" class="form-control" v-bind:class="errors.has('workemail') ? 'is-invalid':''" data-vv-as="workemail" name="workemail" v-model="model.workemail" placeholder="Ex: myname@example.com" />
                            <p v-if="errors.has('workemail') !== null"></p>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col md="5">
                          <label class="labels">Phone 2 </label>
                          <div class="form-group" v-bind:class="errors.has('whatsapp') ? 'has-error':''">
                            <input type="number" class="form-control" v-bind:class="errors.has('whatsapp') ? 'is-invalid':''" data-vv-as="whatsapp" name="whatsapp" v-model="model.whatsapp" placeholder="Enter Phone 2" />
                            <p v-if="errors.has('whatsapp') !== null"></p>
                          </div>
                        </b-col>
                      </b-row>
                    </b-card>
                  </b-collapse>
                  </div>
                  <div class="border-bottom my-2"/>
                  <b-button block v-b-toggle.customer-group class="m-1 mt-2 mb-3" variant="light" style="color:#0056b3!important;">Company Group <font-awesome-icon icon="chevron-down" class="ml-3"/></b-button>
                  <b-collapse id="customer-group">
                    <b-card no-body class="mb-4">
                    <b-row>
                      <b-col class="mt-3">
                        <div class="table-responsive">
                          <table>
                            <thead>
                              <tr class="small-text">
                                <th class="labels" width="500">Company *</th>
                                <th class="labels" width="25"></th>
                                <th class="labels" width="500">Branch *</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(selectedItem, index) in selectedItems" :key="selectedItem.uuid">
                                <td v-if="!selectedItem.isDeleted" class="labels" width="500">
                                  <b-form-input
                                    v-model="selectedItem.nameCompany"
                                    readonly
                                    required
                                    class="mt-3"
                                    id="field-type"
                                  />
                                </td>
                                <td class="labels" width="25"></td>
                                <td v-if="!selectedItem.isDeleted && !selectedItem.uuid" class="labels" width="500">
                                  <b-form-select
                                    v-model="selectedItem.uuidBranch"
                                    required
                                    class="mt-3"
                                    :options="selectedItem.availableBranch"
                                  />
                                </td>
                                <td v-if="!selectedItem.isDeleted && selectedItem.uuid" class="labels" width="500">
                                  <b-form-input
                                    v-model="selectedItem.nameBranch"
                                    readonly
                                    required
                                    class="mt-3"
                                    id="field-type"
                                    :options="selectedItem.availableBranch"
                                  />
                                </td>
                                <td class="labels" width="20"></td>
                                <td v-if="!selectedItem.isDeleted && selectedItem.uuid" class="text-center p-0">
                                  <b-button
                                    pill
                                    style="margin-top:17px!important;font-weight:bold!important;padding-top:0px!important; padding-bottom:0px!important;"
                                    size="sm"
                                    variant="danger"
                                    @click="deleteSelectedItem(index)"
                                  >
                                    x
                                  </b-button>
                                </td>
                                <td v-if="!selectedItem.uuid" class="text-center p-0">
                                  <b-button
                                    pill
                                    style="margin-top:17px!important;font-weight:bold!important;padding-top:0px!important; padding-bottom:0px!important;"
                                    size="sm"
                                    variant="danger"
                                    @click="deleteSelectedItems(index)"
                                  >
                                    x
                                  </b-button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </b-col>
                    </b-row>
                      <b-row>
                        <b-col md="5 mb-3">
                          <b-dropdown text="Add Company Group" variant="dark">
                            <div style="overflow: scroll; height: 250px; border-bottom: 1px solid black">
                              <!-- <b-dropdown-item
                                v-for="availableItem in getRemainingAvailableItems()"
                                :key="availableItem.uuidCompany"
                                @click="() => addToSelected(availableItem)"
                              > -->
                              <b-dropdown-item
                                v-for="availableItem in availableItems"
                                :key="availableItem.uuidCompany"
                                @click="() => addToSelected(availableItem)"
                              >
                                {{ availableItem.nameCompany }}
                              </b-dropdown-item>
                              <b-dropdown-divider></b-dropdown-divider>
                            </div>
                          </b-dropdown>
                        </b-col>
                      </b-row>
                    </b-card>
                  </b-collapse>
                </div>
              <b-row class="mt-5">
                <b-col md="6">
                  <b-button variant="secondary" class="btn-back float-left" @click="goBack()"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button>
                </b-col>
                <b-col md="6">
                  <b-button :variant="$route.params.id !== undefined ? 'warning' : 'primary'" class="btn-back float-right" type="submit"><font-awesome-icon icon="save"></font-awesome-icon> {{$route.params.id !== undefined ? 'Update' : 'Save'}} </b-button>
                </b-col>
              </b-row>
            </form>
            <b-modal id="bv-modal" hide-footer>
              <template v-slot:modal-title>
                <h5 class="text-transform">Add Business Sector</h5>
              </template>
              <form v-on:submit.prevent="doAddDataBusiness()">
                <div class="d-block">
                  <label for="" class="labels">Name *</label>
                  <b-form-input v-model="formData.name" required placeholder="Enter Name"></b-form-input><br>
                  <label for="" class="labels">Note</label>
                  <b-form-textarea rows="3" v-model="formData.note" placeholder="Enter Note"></b-form-textarea>
                </div>
                <b-button class="mt-4" @click="$bvModal.hide('bv-modal')"><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button>
                <b-button variant="primary" type="submit" class="mt-4 float-right"><font-awesome-icon icon="save"></font-awesome-icon> Submit</b-button>
              </form>
            </b-modal>
            <b-modal id="bv-modal-tax" hide-footer>
              <template v-slot:modal-title>
                <h5 class="text-transform">Add Tax Category</h5>
              </template>
              <form v-on:submit.prevent="doAddDataTax()">
                <div class="d-block">
                  <label for=""><strong>Name *</strong></label>
                  <b-form-input v-model="formData.name" required placeholder="Enter Name"></b-form-input><br>
                  <label for=""><strong>Note</strong></label>
                  <b-form-textarea rows="3" v-model="formData.note" placeholder="Enter Note"></b-form-textarea>
                </div>
                <b-button class="mt-4" @click="$bvModal.hide('bv-modal-tax')"><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button>
                <b-button variant="primary" type="submit" class="mt-4 float-right"><font-awesome-icon icon="save"></font-awesome-icon> Submit</b-button>
              </form>
            </b-modal>
            <b-modal id="bv-modal-division" hide-footer>
              <template v-slot:modal-title>
                <h5 class="text-transform">Add Division</h5>
              </template>
              <form v-on:submit.prevent="doAddDataDivision()">
                <div class="d-block">
                  <label for="" class="labels">Name *</label>
                  <b-form-input v-model="formData.name" required placeholder="Enter Name"></b-form-input><br>
                  <label for="" class="labels">Note</label>
                  <b-form-textarea rows="3" v-model="formData.note" placeholder="Enter Note"></b-form-textarea>
                </div>
                <b-button class="mt-4" @click="$bvModal.hide('bv-modal-division')"><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button>
                <b-button variant="primary" type="submit" class="mt-4 float-right"><font-awesome-icon icon="save"></font-awesome-icon> Submit</b-button>
              </form>
            </b-modal>
            <b-modal id="bv-modal-position" hide-footer>
              <template v-slot:modal-title>
                <h5 class="text-transform">Add Position</h5>
              </template>
              <form v-on:submit.prevent="doAddDataPosition()">
                <div class="d-block">
                  <label for="" class="labels">Name *</label>
                  <b-form-input v-model="formData.name" required placeholder="Enter Name"></b-form-input><br>
                  <label for="" class="labels">Note</label>
                  <b-form-textarea rows="3" v-model="formData.note" placeholder="Enter Note"></b-form-textarea>
                </div>
                <b-button class="mt-4" @click="$bvModal.hide('bv-modal-position')"><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button>
                <b-button variant="primary" type="submit" class="mt-4 float-right"><font-awesome-icon icon="save"></font-awesome-icon> Submit</b-button>
              </form>
            </b-modal>
        </b-card>
    </div>
</template>

<script>
    export default {
        name: 'customer-form',
        data () {
            return {
              isLoading: false,
              isLoadingBranch: false,
              availableItems: [],
              selectedItems: [],
              selectedItem: {
                uuidCompany: null,
                uuidBranch: null,
                nameBranch: '',
                nameCompany: '',
                availableBranch: [
                  { text: '', value: '' }
                ]
              },
              socialMedias:[],
              socialMedia: {},
              apiUrl: {
                customer: window.AppConfig.apiUrl + 'customer', 
              },
              urlName: null,
              model: {
                type: 'Company',
                company: null,
                branch: '',
                businessSector: '',
                // status: null,
                marketSegment: null,
                website: '',
                fax: '',
                city: null,
                state: 'Indonesia',
                postalCode: '',
                description: '',
                taxId: '',
                // taxCategory: '',
                name: '',
                gender: '',
                email: '',
                workemail: '',
                workphone: '',
                address: '',
                picName: '',
                divisionCustomer: '',
                positionCustomer: '',
                salesType: '',
                whatsapp: '',
                phone: '',
                // accountNumber: '',
                // accountName: '',
                // bank: null,
                // accountType: null,
                // accountSubtype: null
              },
              typeList: [
                {
                  value: 'Company',
                  text: 'Company'
                },
                {
                  value: 'Personal',
                  text: 'Personal'
                }
              ],
              statusList: [
                {
                  value: null,
                  text: 'Please Select Status'
                },
                {
                  value: 'Converted',
                  text: 'Converted'
                },
                {
                  value: 'Interested',
                  text: 'Interested'
                },
                {
                  value: 'Lead',
                  text: 'Lead'
                },
                {
                  value: 'Open',
                  text: 'Open'
                },
                {
                  value: 'Opportunity',
                  text: 'Opportunity'
                },
                {
                  value: 'Quotation',
                  text: 'Quotation'
                },
                {
                  value: 'Replied',
                  text: 'Replied'
                },
                {
                  value: 'Other',
                  text: 'Other'
                }
              ],
              taxCategoryList: [
                {
                  value: '',
                  text: 'Please Select Tax Category'
                },
              ],
              positionList: [
                {
                  value: '',
                  text: 'Please Select Position'
                },
              ],
              businessSectorList: [
                {
                  value: '',
                  text: 'Please Select Business Sector'
                }
              ],
              genderList: [
                {
                  value: '',
                  text: 'Please Select Gender'
                },
                {
                  value: 'Male',
                  text: 'Male'
                },
                {
                  value: 'Female',
                  text: 'Female'
                },
              ],
              divisionList: [
                {
                  value: '',
                  text: 'Please Select Division'
                },
              ],
              companyList: [],
              branchList: [{
                value: '',
                text: 'Please Select Branch'
              }],
              stateList: [
                {
                  value: 'Indonesia',
                  text: 'Indonesia'
                },
                {
                  value: 'Malaysia',
                  text: 'Malaysia'
                }
              ],
              cityListRM: [
                {
                  value: null,
                  text: 'Please Select City'
                },
                {
                  value: 'Ipoh',
                  text: 'Ipoh'
                },
                {
                  value: 'Johor Bahru',
                  text: 'Johor Bahru'
                },
                {
                  value: 'Klang',
                  text: 'Klang'
                },
                {
                  value: 'Kelantan',
                  text: 'Kelantan'
                },
                {
                  value: 'Kota Kinabalu',
                  text: 'Kota Kinabalu'
                },
                {
                  value: 'Kuala Lumpur',
                  text: 'Kuala Lumpur'
                },
                {
                  value: 'Kuching',
                  text: 'Kuching'
                },
                {
                  value: 'Melaka',
                  text: 'Melaka'
                },
                {
                  value: 'Penang',
                  text: 'Penang'
                },
                {
                  value: 'Sabah',
                  text: 'Sabah'
                },
                {
                  value: 'Seberang Parai',
                  text: 'Seberang Parai'
                },
                {
                  value: 'Taiping',
                  text: 'Taiping'
                },
                {
                  value: 'Other',
                  text: 'Other'
                }
              ],
              cityListID: [
                {
                  value: null,
                  text: 'Please Select City'
                },
                {
                  value: 'Aceh',
                  text: 'Aceh'
                },
                {
                  value: 'Bali',
                  text: 'Bali'
                },
                {
                  value: 'Bandung',
                  text: 'Bandung'
                },
                {
                  value: 'Banjarmasin',
                  text: 'Banjarmasin'
                },
                {
                  value: 'Binjai',
                  text: 'Binjai'
                },
                {
                  value: 'Bekasi',
                  text: 'Bekasi'
                },
                {
                  value: 'Bogor',
                  text: 'Bogor'
                },
                {
                  value: 'Depok',
                  text: 'Depok'
                },
                {
                  value: 'Jakarta',
                  text: 'Jakarta'
                },
                 {
                  value: 'Langkat',
                  text: 'Langkat'
                },
                {
                  value: 'Makassar',
                  text: 'Makassar'
                },
                {
                  value: 'Manado',
                  text: 'Manado'
                },
                {
                  value: 'Mandailing Natal',
                  text:'Mandailing Natal'
                },
                {
                  value: 'Medan',
                  text: 'Medan'
                },
                {
                  value: 'Malang',
                  text: 'Malang'
                },
                {
                  value: 'Padang',
                  text: 'Padang'
                },
                {
                  value: 'Padangsidempuan',
                  text: 'Padangsidempuan'
                },
                {
                  value: 'Palembang',
                  text: 'Palembang'
                },
                {
                  value: 'Papua',
                  text: 'Papua'
                },
                {
                  value: 'Pematangsiantar',
                  text: 'Pematangsiantar'
                },
                {
                  value: 'Pekanbaru',
                  text: 'Pekanbaru'
                },
                {
                  value: 'Samarinda',
                  text: 'Samarinda'
                },
                {
                  value: 'Sibolga',
                  text: 'Sibolga',
                },
                {
                  value: 'Semarang',
                  text: 'Semarang'
                },
                {
                  value: 'Serdang Bedagai',
                  text: 'Serdang Bedagai'
                },
                {
                  value: 'Stabat',
                  text: 'Stabat',
                },
                {
                  value: 'Surabaya',
                  text: 'Surabaya'
                },
                {
                  value: 'Tanjungbalai',
                  text: 'Tanjungbalai',
                },
                {
                  value: 'Tebing Tinggi',
                  text: 'Tebing Tinggi'
                },
                {
                  value: 'Other',
                  text: 'Other'
                }
              ],
              bankList: [
                {
                  value: null,
                  text: 'Please Select Bank'
                },
                {
                  value: 'Maybank',
                  text: 'Maybank'
                },
                {
                  value: 'CIMB Bank',
                  text: 'CIMB Bank'
                },
                {
                  value: 'RHB Bank',
                  text: 'RHB Bank'
                },
                {
                  value: 'Hong Leong Bank',
                  text: 'Hong Leong Bank'
                },
                {
                  value: 'Bank Mandiri',
                  text: 'Bank Mandiri'
                },
                {
                  value: 'Bank Negara Indonesia (BNI)',
                  text: 'Bank Negara Indonesia (BNI)'
                },
                {
                  value: 'Bank Rakyat Indonesia (BRI)',
                  text: 'Bank Rakyat Indonesia (BRI)'
                },
              ],
              marketSegmentList: [
                {
                  value: null,
                  text: 'Please Select Market Segment'
                },
                {
                  value: 'Upper Income',
                  text: 'Upper Income'
                },
                {
                  value: 'Middle Income',
                  text: 'Middle Income'
                },
                {
                  value: 'Lower Income',
                  text: 'Lower Income'
                },
                {
                  value: 'Other',
                  text: 'Other'
                }
              ],
              salesTypeList: [
                {
                  value: '',
                  text: 'Please Select Sales Type'
                },
                {
                  value: 'Corporate',
                  text: 'Corporate'
                },
                {
                  value: 'Personal',
                  text: 'Personal'
                }
              ],
              accountTypeList: [
                {
                  value: null,
                  text: 'Please Select Account Type'
                },
                {
                  value: 'Brokerage Account',
                  text: 'Brokerage Account'
                },
                {
                  value: 'Certificate of Deposit',
                  text: 'Certificate of Deposit'
                },
                {
                  value: 'Checking Account',
                  text: 'Checking Account'
                },
                {
                  value: 'Company Account',
                  text: 'Company Account'
                },
                {
                  value: 'Current Account',
                  text: 'Current Account'
                },
                {
                  value: 'Individual Account',
                  text: 'Individual Account'
                },
                {
                  value: 'Saving Account',
                  text: 'Saving Account'
                }
              ],
              accountSubtypeList: [
                {
                  value: null,
                  text: 'Please Select Account Subtype'
                },
                {
                  value: 'Debit',
                  text: 'Debit'
                },
                {
                  value: 'MasterCard',
                  text: 'MasterCard'
                },
                {
                  value: 'Visa',
                  text: 'Visa'
                }
              ],
              modelValidations: {
                lead: {
                  required: true
                },
                type: {
                  required: true
                },
                company: {
                  required: true
                },
                branch: {
                  required: true
                },
                gender: {
                  required: true
                },
                marketSegment: {
                  required: true
                },
                status: {
                  required: true
                },
                businessSector: {
                  required: true
                },
                division: {
                  required: true
                },
                position: {
                  required: true
                },
                taxCategory: {
                  required: true
                },
                accountType: {
                  required: true
                },
                accountSubtype: {
                  required: true
                },
                state: {
                  required: true
                },
                city: {
                  required: true
                }
              },
              formData: {
                name: null,
                note: null
              }
            }
        },
        mounted () {
          this.initData()
          this.getCompany()
          this.getBusinessSector()
          this.getDivision()
          this.getPosition()
          this.fetchAvailableItemsCompany()
          // this.fetchAvailableItemsBranch(companyUuid)
        },
        methods: {
          fetchAvailableItemsCompany: async function() {
            const response = await this.$http.get(window.AppConfig.apiUrl + 'company?limit=100');
            console.log(response)
            this.availableItems = response.data._embedded.company.map(availableItem => ({
              uuidCompany: availableItem.uuid,
              nameCompany: availableItem.name
            }))
          },
          fetchAvailableItemsBranch: async function(companyUuid = null) {
            console.log('Selected Company:', companyUuid[0]);
            const response = await this.$http.get(window.AppConfig.apiUrl + 'branch?limit=100&company_uuid=' + companyUuid + '&is_active=1')
            console.log("Companyuuid", response)
            return response.data._embedded.branch.map(branches => ({ text: branches.name, value: branches.uuid}));
          },
          deleteSelectedItems: function(index) {
            this.selectedItems.splice(index, 1);
          },
          deleteSelectedItem: function(index) {
            this.selectedItems[index].isDeleted = true;
          },
          getRemainingAvailableItems: function() {
            const selectedItemsUUID = this.selectedItems.map(({ uuidCompany }) => uuidCompany);
            return this.availableItems.filter(
              (availableItem) => !selectedItemsUUID.includes(availableItem.uuidCompany),
            );
          },
          addToSelected: async function(item) {
            this.selectedItems.push({
              ...item,
              availableBranch: await this.fetchAvailableItemsBranch(item.uuidCompany)
            });
            // console.log(this.selectedItems);
          },
          addSocialMedia(){
            this.socialMedias.push({
              name: ''
            });
          },
          deleteSocialMedia(index){
            this.socialMedias.splice(index,1);
          },
          initData () {
            if (this.$route.params.id !== undefined) {
              this.getDetail()
            }
          },
          getDetail () {
            this.isLoading = true
            this.$http.get(this.apiUrl.customer + '/' + this.$route.params.id).then(response => {
              this.model.type = response.data.type
              this.model.name = response.data.name
              this.model.gender = response.data.gender
              this.model.address = response.data.address
              this.model.salesType = response.data.salesType
              this.model.workphone = response.data.workphone
              this.model.email = response.data.email
              this.model.workemail = response.data.workemail
              this.model.taxId = response.data.taxId
              this.model.description = response.data.description
              this.model.businessSector = response.data.businessSector.uuid
              this.model.fax = response.data.fax
              this.model.marketSegment = response.data.marketSegment
              this.model.website = response.data.website
              this.model.city = response.data.city
              this.model.state = response.data.state
              this.model.postalCode = response.data.postalCode
              this.model.picName = response.data.picName
              this.model.divisionCustomer = response.data.divisionCustomer !== undefined && response.data.divisionCustomer !== null && response.data.divisionCustomer !== '' && response.data.divisionCustomer !== 'null' ? response.data.divisionCustomer.uuid : ''
              this.model.positionCustomer = response.data.positionCustomer !== null && response.data.positionCustomer !== '' && response.data.positionCustomer !== 'null' ? response.data.positionCustomer.uuid : ''
              this.model.whatsapp = response.data.whatsapp
              this.model.phone = response.data.phone
              if (response.data.customerCompany !== null) {
                this.selectedItems = response.data.customerCompany.map((selectedItem) => {
                  const branchesUuid = selectedItem.branch.uuid
                  const branchesName = selectedItem.branch.name
                  return {
                    uuid: selectedItem.uuid,
                    nameCompany: selectedItem.company.name,
                    uuidCompany: selectedItem.company.uuid,
                    availableBranch: [
                      { text: selectedItem.branch.name, value: selectedItem.branch.uuid }
                    ],
                    uuidBranch: branchesUuid,
                    nameBranch: branchesName,
                    isDeleted: false,
                  };
                });
              }
              if (response.data.socialMedia !== null) {
                this.socialMedias = response.data.socialMedia.map((socialMedia) => {
                  const jsonnn = JSON.stringify(socialMedia)
                  return {
                    name: JSON.parse(jsonnn.replace(/(\{|,)\s*(.+?)\s*:/g, '$1 "$2":'))
                  };
                });
              }
            })
          },
          doEdit () {
            const toEdit = this.selectedItems.map(selectedItem => ({
              uuid: selectedItem.uuid ? selectedItem.uuid : "",
              companyId: selectedItem.uuidCompany,
              branchId: selectedItem.uuidBranch,
              delete: selectedItem.isDeleted ? 1 : 0,
            }));

            this.$validator.validateAll().then(res => {
              if (res) {
                let formData = new FormData()
                formData.append('type', this.model.type)
                formData.append('businessSector', this.model.businessSector)
                formData.append('name', this.model.name)
                formData.append('marketSegment', this.model.marketSegment)
                formData.append('phone', this.model.phone)
                formData.append('fax', this.model.fax)
                formData.append('website', this.model.website)
                formData.append('socialMedia', JSON.stringify(this.socialMedias.map(socialMedia => socialMedia.name)))
                formData.append('description', this.model.description)
                formData.append('email', this.model.email)
                formData.append('taxId', this.model.taxId)
                formData.append('address', this.model.address)
                formData.append('state', this.model.state)
                formData.append('city', this.model.city)
                formData.append('postalCode', this.model.postalCode)
                formData.append('salesType', this.model.salesType)
                formData.append('picName', this.model.picName)
                formData.append('gender', this.model.gender)
                formData.append('divisionCustomer', this.model.divisionCustomer)
                formData.append('positionCustomer', this.model.positionCustomer)
                formData.append('workphone', this.model.workphone)
                formData.append('workemail', this.model.workemail)
                formData.append('whatsapp', this.model.whatsapp)
                formData.append('customerCompany', JSON.stringify(toEdit))
                if (this.$route.params.id !== undefined) {
                  this.$http.patch(this.apiUrl.customer + '/' + this.$route.params.id, formData).then(response => {
                    this.$store.dispatch('notification/success', 'Customer has been updated.')
                    window.location.href = document.URL.replace('/edit', '')
                  }).catch(error => {
                    // this.$store.dispatch('notification/error', 'Please fill all the required(*) fields')
                    swal("", "Please fill all the required(*) fields!", "info", {
                      buttons: false,
                      timer: 2000
                    });
                  })
                }
              } else {
                swal("", "Please fill all the required(*) fields!", "info", {
                  buttons: false,
                  timer: 2000
                });
              }
            })
          },
          getCompany () {
            this.$http.get(window.AppConfig.apiUrl + 'company?limit=1000').then(resp => {
              this.companyList = []
              resp.data._embedded.company.forEach(data => {
                this.companyList.push({
                  value: data.uuid,
                  text: data.name
                })
              })
            })
          },
          getBusinessSector () {
            this.$http.get(window.AppConfig.apiUrl + 'business-sector?limit=1000').then(resp => {
              this.businessSectorList = [
                {
                  value: '',
                  text: 'Please Select Business Sector'
                }
              ]
              resp.data._embedded.business_sector.forEach(data => {
                this.businessSectorList.push({
                  value: data.uuid,
                  text: data.name
                })
              })
            })
          },
          getTaxCategory () {
            this.$http.get(window.AppConfig.apiUrl + 'tax-category?limit=1000').then(resp => {
              this.taxCategoryList = [
                {
                  value: '',
                  text: 'Please Select Tax Category'
                }
              ]
              resp.data._embedded.tax_category.forEach(data => {
                this.taxCategoryList.push({
                  value: data.uuid,
                  text: data.name
                })
              })
            })
          },
          getDivision () {
            this.$http.get(window.AppConfig.apiUrl + 'division-customer?limit=1000').then(resp => {
              this.divisionList = [
                {
                  value: '',
                  text: 'Please Select Division'
                }
              ]
              resp.data._embedded.division_customer.forEach(data => {
                this.divisionList.push({
                  value: data.uuid,
                  text: data.name
                })
              })
            })
          },
          getPosition () {
            this.$http.get(window.AppConfig.apiUrl + 'position-customer?limit=1000').then(resp => {
              this.positionList = [
                {
                  value: '',
                  text: 'Please Select Position'
                }
              ]
              resp.data._embedded.position_customer.forEach(data => {
                this.positionList.push({
                  value: data.uuid,
                  text: data.name
                })
              })
            })
          },
          getDateTime (value) {
            if (value !== null) {
              return this.$moment(value).format('DD MMM YYYY HH:mm A')
            } else {
              return '-'
            }
          },
          goBack () {
            window.goBack(this)
          },
          showModalBusiness () {
            this.formData.name = null
            this.formData.note = null
            this.$bvModal.show('bv-modal')
          },
          doAddDataBusiness () {
            this.isLoading = true
            this.$http.post(window.AppConfig.apiUrl + 'business-sector', {
              name: this.formData.name,
              note: this.formData.note
            })
            .then((resp) => {
              this.isLoading = false
              this.formData.name = null
              this.formData.note = null
              this.getBusinessSector()
              this.$bvModal.hide('bv-modal')
              this.$store.dispatch('notification/success', 'Business Sector has been added')
            })
            .catch(error => {
              this.isLoading = false
              this.$store.dispatch('notification/error', error)
            });
          },
          showModalTax () {
            this.formData.name = null
            this.formData.note = null
            this.$bvModal.show('bv-modal-tax')
          },
          doAddDataTax () {
            this.isLoading = true
            this.$http.post(window.AppConfig.apiUrl + 'tax-category', {
              name: this.formData.name,
              note: this.formData.note
            })
            .then((resp) => {
              this.isLoading = false
              this.formData.name = null
              this.formData.note = null
              this.getTaxCategory()
              this.$bvModal.hide('bv-modal-tax')
              this.$store.dispatch('notification/success', 'Tax Category has been added')
            })
            .catch(error => {
              this.isLoading = false
              this.$store.dispatch('notification/error', error)
            });
          },
          showModalDivision () {
            this.formData.name = null
            this.formData.note = null
            this.$bvModal.show('bv-modal-division')
          },
          doAddDataDivision () {
            this.isLoading = true
            this.$http.post(window.AppConfig.apiUrl + 'division-customer', {
              name: this.formData.name,
              note: this.formData.note
            })
            .then((resp) => {
              this.isLoading = false
              this.formData.name = null
              this.formData.note = null
              this.getDivision()
              this.$bvModal.hide('bv-modal-division')
              this.$store.dispatch('notification/success', 'Division has been added')
            })
            .catch(error => {
              this.isLoading = false
              this.$store.dispatch('notification/error', error)
            });
          },
          showModalPosition () {
            this.formData.name = null
            this.formData.note = null
            this.$bvModal.show('bv-modal-position')
          },
          doAddDataPosition () {
            this.isLoading = true
            this.$http.post(window.AppConfig.apiUrl + 'position-customer', {
              name: this.formData.name,
              note: this.formData.note
            })
            .then((resp) => {
              this.isLoading = false
              this.formData.name = null
              this.formData.note = null
              this.getPosition()
              this.$bvModal.hide('bv-modal-position')
              this.$store.dispatch('notification/success', 'Position has been added')
            })
            .catch(error => {
              this.isLoading = false
              this.$store.dispatch('notification/error', error)
            });
          }
        }
    }
</script>